<script lang="ts">
  import { cn } from '$lib/utils';
  import { EditorJs } from 'query-strapi-v4';
  type Block = $$Generic<EditorJs.Quote | undefined>;
  export let block = undefined as Block;
</script>

<figure
  class={cn(
    {
      'text-left': block.data.alignment === 'left',
      'text-center': block.data.alignment === 'center'
    },
    'not-prose bg-zinc-100 dark:bg-zinc-800 py-8 px-6 rounded-md'
  )}
>
  <svg
    aria-hidden="true"
    class={cn(
      { 'mx-auto': block.data.alignment === 'center' },
      'w-10 h-10 text-gray-400 dark:text-zinc-50'
    )}
    viewBox="0 0 24 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ><path
      d="M14.017 18L14.017 10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983L9.983 18L0 18Z"
      fill="currentColor"
    /></svg
  >
  <blockquote class={cn('italic')}>
    {@html block.data.text}
  </blockquote>
  {#if block.data.caption}
    <figcaption class="text-sm font-semibold mt-2">
      - {block.data.caption}
    </figcaption>
  {/if}
</figure>
